<div id="cookie-banner" *ngIf="displayBanner">
  <img src="../../../../assets/icons/Close.svg" (click)="closeBanner()"/>
  <div class="description-container" [innerHTML]="'cookiesBanner.paragraph' | translate"></div>

  <div class="button-container">
    <button (click)="acceptCookies()" [innerHTML]="'cookiesBanner.buttons.manage' | translate"></button>
  </div>
</div>